import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'batch_number': {
    title: '批次号',
    type: 'input',
    equation: all,
    slot: true
  },
  'file_name': {
    title: '附件名称',
    type: 'input',
    equation: cusname,
    width: 'auto'
  },
  'batch_type': {
    describe: true,
    title: '批导类型',
    type: 'select',
    equation: all,
    dictionary: 'A0044',
    width: 250
  },
  'batch_status': {
    describe: true,
    title: '批导处理状态',
    type: 'select',
    equation: city,
    dictionary: 'A0030'
  },
  'batch_name': {
    title: '批导人',
    type: 'input',
    equation: cusname
  },
  'datum': {
    title: '批导日期',
    type: 'date',
    equation: city,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  }
}



// WEBPACK FOOTER //
// ./src/views/invoice-manage/config/BatchQuery.js